import { gql } from "@/services/httpAdapter";

// Common fragments
import { AddedCompensationFragment, CompensationFragment, ReviewFragment } from "@/Washouts/api/common/fragments";

// Fragments

export function getOnUpdateSalesDepartmentalWashout() {
	return gql`
		subscription onUpdateSalesDepartmentalWashout(
			$commissionCycleId: String
			$payPeriodId: String
			$userId: String
			$position: String
		) {
			onUpdateSalesDepartmentalWashout(
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				userId: $userId
				position: $position
			) {
				_id
				commissionCycleId
				payPeriodId
				userId
				deductions {
					deductions {
						_id
						title
						value
					}
					total
				}
				review {
					...Review
				}
				addedCompensations {
					...AddedCompensation
				}
				summary {
					...Compensation
				}
			}
		}
		${AddedCompensationFragment}
		${CompensationFragment}
		${ReviewFragment}
	`;
}

export function getOnUpdateSalesDepartmentalWashoutStatus() {
	return gql`
		subscription onUpdateSalesDepartmentalWashoutStatus(
			$commissionCycleId: String
			$payPeriodId: String
			$userId: String
			$position: String
		) {
			onUpdateSalesDepartmentalWashoutStatus(
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				userId: $userId
				position: $position
			) {
				_id
				commissionCycleId
				payPeriodId
				userId
				position
				status
				employee {
					position
				}
				review {
					...Review
				}
			}
		}
		${ReviewFragment}
	`;
}

export function getOnNewSalesDepartmentalWashoutAvailable() {
	return gql`
		subscription onNewSalesDepartmentalWashoutAvailable($commissionCycleId: String, $payPeriodId: String, $userId: String) {
			onNewSalesDepartmentalWashoutAvailable(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, userId: $userId) {
				_id
				commissionCycleId
				payPeriodId
				userId
				deductions {
					deductions {
						_id
						title
						value
					}
					total
				}
			}
		}
	`;
}
